import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faComment } from '@fortawesome/free-solid-svg-icons'


function Home() {

    const [name, setName] = useState('');
    const dispatch = useDispatch();

    const submitHandler = () => {
        dispatch({ type: "LOGIN", payload: { name } })
    }

    <button onClick={submitHandler}> SUBMIT</button>
    return (
        <div>
            <div className="banner-container">
                <div className="banner">
                    <h1>SuperChat
                        <FontAwesomeIcon icon = {faComment}></FontAwesomeIcon>
                    </h1>
                    <h3>
                        Blazing fast chat application with best in class user privacy and auto message destruction!!
                    </h3>
                    <div className="banner-input-container">
                        <input
                            onKeyPress={(e) => { return e.key === 'Enter' ? submitHandler() : null }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter Username..."></input>
                        <button onClick={submitHandler}>ENTER
                            <FontAwesomeIcon className="right-icon" icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
